import "jquery";
import _ from "lodash";
import "./positions.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Tabla de posiciones";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/

//create the seasons select
//let select = document.createElement("select");
// page_template_content.appendChild();
let temporada_title = document.createElement("h3");
temporada_title.textContent = "Temporada";
page_template_content.appendChild(temporada_title);

let season_selector = document.createElement("select");
season_selector.classList.add("selector");
page_template_content.appendChild(season_selector);
setSeasons(season_selector);
season_selector.addEventListener("change", (e) => {});

//load tabs and panels
let conference_data_list = document.createElement("dl");
conference_data_list.classList.add("tabs");
page_template_content.appendChild(conference_data_list);

let conference_panel_container = document.createElement("div");
conference_panel_container.classList.add("tabs_content");
conference_panel_container.id = "conference_panel_container";
page_template_content.appendChild(conference_panel_container);

setConferencesTabs(
  id_season,
  conference_data_list,
  conference_panel_container,
  true
);
season_selector.addEventListener("change", (e) => {
  setConferencesTabs(
    e.target.value,
    conference_data_list,
    conference_panel_container
  );
});
/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/
async function setSeasons(container) {
  let table_data = await getSeasons().then((response) => {
    let select_options = [];

    if (response.items.length > 0) {
      response.items.forEach((element) => {
        let option = document.createElement("option");
        option.value = element.id;
        option.innerHTML = element.name;

        select_options.push(option);
      });
    } else {
      //if there are no seasons
      let option = document.createElement("option");
      option.value = "";
      option.innerHTML = "Sin temporadas";

      select_options.push(option);
    }
    return select_options;
  });

  table_data.map((item) => {
    return container.appendChild(item);
  });

  return container;
}

//create a table with an array of headers
function createTableWithHeader(header_titles) {
  let table = document.createElement("table");
  table.classList.add("table");
  let thead = document.createElement("thead");
  let thead_tr = document.createElement("tr");
  header_titles.map((item) => {
    let th = document.createElement("th");
    th.innerText = item;
    thead_tr.appendChild(th);
  });
  thead.appendChild(thead_tr);
  table.appendChild(thead);

  return table;
}

async function setConferencesTabs(
  id_season,
  conference_data_list,
  conference_panel_container,
  first_load = false
) {
  //empty tables
  conference_data_list.innerHTML = "";
  conference_panel_container.innerHTML = "";
  let display_first = first_load;

  let tables = await getConferences(id_season).then((response) => {
    //create conference tabs
    if (response.items.length > 0) {
      response.items.forEach(function (item) {
        let id_conference_first_result = item.id;
        let description_detail = document.createElement("dd");
        description_detail.classList.add("tab_tittle");

        let description_detail_tab_link = document.createElement("a");
        description_detail_tab_link.innerText = item.name;
        description_detail_tab_link.href = "#div_conference_" + item.id;
        description_detail_tab_link.addEventListener("click", () => {
          let conference_panel = document.querySelectorAll(
            "#conference_panel_container"
          );

          conference_panel[0].childNodes.forEach((node) => {
            if (node.id == "div_conference_" + item.id) {
              node.style.display = "";
            } else {
              node.style.display = "none";
            }
          });
        });

        description_detail.appendChild(description_detail_tab_link);
        conference_data_list.appendChild(description_detail);

        //i need to create all tables in conference_panel
        //set panels
        let conference_panel = document.createElement("div");
        conference_panel.id = "div_conference_" + item.id;

        if (display_first == true) {
          conference_panel.style.display = "";
        } else {
          display_first = false;
        }

        //table
        let tbl_points = createTableWithHeader([
          "#",
          "Equipo",
          "JJ",
          "JG",
          "JP",
          "P. Favor",
          "P. Contra",
          "Dif.",
          "Puntos"
        ]);

        let tbl_offensive = createTableWithHeader([
          "#",
          "Equipo",
          "Puntos",
          "Prom."
        ]);

        let tbl_defensive = createTableWithHeader([
          "#",
          "Equipo",
          "Puntos",
          "Prom."
        ]);

        let tbl_positions_local = createTableWithHeader([
          "#",
          "Equipo",
          "JJ",
          "JG",
          "JP",
          "P. Favor",
          "P. Contra",
          "Dif."
        ]);

        let tbl_positions_visitor = createTableWithHeader([
          "#",
          "Equipo",
          "JJ",
          "JG",
          "JP",
          "P. Favor",
          "P. Contra",
          "Dif."
        ]);

        //add tables to panel
        conference_panel.appendChild(tbl_points);
        conference_panel.appendChild(tbl_offensive);
        conference_panel.appendChild(tbl_defensive);
        conference_panel.appendChild(tbl_positions_local);
        conference_panel.appendChild(tbl_positions_visitor);

        //load table points
        getTable(id_season, "/sports/standings/season").then((response) => {
          let tbl_body = document.createElement("tbody");

          let items = response.items_standing;

          items.forEach((item) => {
            let id_conference = 0;

            response.item_season.participants.forEach((item_participant) => {
              if (item_participant.id === item.team.id_entity) {
                if (item_participant.pivot.id_conference !== null) {
                  id_conference = item_participant.pivot.id_conference;
                }

                return;
              }
            });

            if (id_conference == id_conference_first_result) {
              let tbl_row = document.createElement("tr");

              let place = document.createElement("td");
              place.innerText = item.place === "0" ? "N/A" : item.place;
              let team = document.createElement("td");
              team.innerText = item.team.name;
              let games = document.createElement("td");
              games.innerText = item.games;
              let games_lost = document.createElement("td");
              games_lost.innerText = item.games_lost;
              let games_won = document.createElement("td");
              games_won.innerText = item.games_won;
              let points_favour = document.createElement("td");
              points_favour.innerText = item.points_in_favor;
              let points_against = document.createElement("td");
              points_against.innerText = item.points_against;
              let dif = document.createElement("td");
              dif.innerText = item.points_in_favor - item.points_against;
              let points = document.createElement("td");
              points.innerText = item.points;
              //add all tds to table body
              [
                place,
                team,
                games,
                games_won,
                games_lost,
                points_favour,
                points_against,
                dif,
                points
              ].map((td) => {
                tbl_row.appendChild(td);
              });

              tbl_body.appendChild(tbl_row);
            }
          });

          tbl_points.appendChild(tbl_body);
        });

        //load table ofensive
        getTable(id_season, "/sports/offensive_standings/season").then(
          (response) => {
            let tbl_body = document.createElement("tbody");

            let items = response.items_standing;

            items.forEach((item) => {
              let id_conference = 0;

              response.item_season.participants.forEach((item_participant) => {
                if (item_participant.id === item.team.id_entity) {
                  if (item_participant.pivot.id_conference !== null) {
                    id_conference = item_participant.pivot.id_conference;
                  }

                  return;
                }
              });

              if (id_conference == id_conference_first_result) {
                let tbl_row = document.createElement("tr");

                let place = document.createElement("td");
                place.innerText = item.place === "0" ? "N/A" : item.place;
                let team = document.createElement("td");
                team.innerText = item.team.name;
                let points = document.createElement("td");
                points.innerText = item.points;
                let prom = document.createElement("td");
                prom.innerText = item.average;

                //add all tds to table body
                [place, team, points, prom].map((td) => {
                  tbl_row.appendChild(td);
                });

                tbl_body.appendChild(tbl_row);
              }
            });

            tbl_offensive.appendChild(tbl_body);
          }
        );

        //load table defensive
        getTable(id_season, "/sports/defensive_standings/season").then(
          (response) => {
            let tbl_body = document.createElement("tbody");

            let items = response.items_standing;

            items.forEach((item) => {
              let id_conference = 0;

              response.item_season.participants.forEach((item_participant) => {
                if (item_participant.id === item.team.id_entity) {
                  if (item_participant.pivot.id_conference !== null) {
                    id_conference = item_participant.pivot.id_conference;
                  }

                  return;
                }
              });

              if (id_conference == id_conference_first_result) {
                let tbl_row = document.createElement("tr");

                let place = document.createElement("td");
                place.innerText = item.place === "0" ? "N/A" : item.place;
                let team = document.createElement("td");
                team.innerText = item.team.name;
                let points = document.createElement("td");
                points.innerText = item.points;
                let prom = document.createElement("td");
                prom.innerText = item.average;

                //add all tds to table body
                [place, team, points, prom].map((td) => {
                  tbl_row.appendChild(td);
                });

                tbl_body.appendChild(tbl_row);
              }
            });

            tbl_defensive.appendChild(tbl_body);
          }
        );

        //load table position local
        getTable(id_season, "/sports/local_standings/season").then(
          (response) => {
            let tbl_body = document.createElement("tbody");

            let items = response.items_standing;

            items.forEach((item) => {
              let id_conference = 0;

              response.item_season.participants.forEach((item_participant) => {
                if (item_participant.id === item.team.id_entity) {
                  if (item_participant.pivot.id_conference !== null) {
                    id_conference = item_participant.pivot.id_conference;
                  }

                  return;
                }
              });

              if (id_conference == id_conference_first_result) {
                let tbl_row = document.createElement("tr");

                let place = document.createElement("td");
                place.innerText = item.place === "0" ? "N/A" : item.place;
                let team = document.createElement("td");
                team.innerText = item.team.name;
                let games = document.createElement("td");
                games.innerText = item.games;
                let games_lost = document.createElement("td");
                games_lost.innerText = item.games_lost;
                let games_won = document.createElement("td");
                games_won.innerText = item.games_won;
                let points_favour = document.createElement("td");
                points_favour.innerText = item.points_in_favor;
                let points_against = document.createElement("td");
                points_against.innerText = item.points_against;
                let dif = document.createElement("td");
                dif.innerText = item.points_in_favor - item.points_against;
                //add all tds to table body
                [
                  place,
                  team,
                  games,
                  games_won,
                  games_lost,
                  points_favour,
                  points_against,
                  dif
                ].map((td) => {
                  tbl_row.appendChild(td);
                });

                tbl_body.appendChild(tbl_row);
              }
            });

            tbl_positions_local.appendChild(tbl_body);
          }
        );

        //load table position visitor
        getTable(id_season, "/sports/visitor_standings/season").then(
          (response) => {
            let tbl_body = document.createElement("tbody");

            let items = response.items_standing;

            items.forEach((item) => {
              let id_conference = 0;

              response.item_season.participants.forEach((item_participant) => {
                if (item_participant.id === item.team.id_entity) {
                  if (item_participant.pivot.id_conference !== null) {
                    id_conference = item_participant.pivot.id_conference;
                  }

                  return;
                }
              });

              if (id_conference == id_conference_first_result) {
                let tbl_row = document.createElement("tr");

                let place = document.createElement("td");
                place.innerText = item.place === "0" ? "N/A" : item.place;
                let team = document.createElement("td");
                team.innerText = item.team.name;
                let games = document.createElement("td");
                games.innerText = item.games;
                let games_lost = document.createElement("td");
                games_lost.innerText = item.games_lost;
                let games_won = document.createElement("td");
                games_won.innerText = item.games_won;
                let points_favour = document.createElement("td");
                points_favour.innerText = item.points_in_favor;
                let points_against = document.createElement("td");
                points_against.innerText = item.points_against;
                let dif = document.createElement("td");
                dif.innerText = item.points_in_favor - item.points_against;
                //add all tds to table body
                [
                  place,
                  team,
                  games,
                  games_won,
                  games_lost,
                  points_favour,
                  points_against,
                  dif
                ].map((td) => {
                  tbl_row.appendChild(td);
                });

                tbl_body.appendChild(tbl_row);
              }
            });

            tbl_positions_visitor.appendChild(tbl_body);
          }
        );

        conference_panel_container.appendChild(conference_panel);
      });
    }
  });
}

//ajax calls
async function getSeasons() {
  var ajax_data = {};

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/seasons/all",
    data: ajax_data,
    async: false
  });
}

async function getConferences(id_season) {
  var ajax_data = {
    id_season: id_season
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/conferences/filtered",
    data: ajax_data,
    async: false
  });
}

async function getTable(id_season, endpoint) {
  var ajax_data = {
    id_season: id_season
  };

  return $.ajax({
    type: "POST",
    url: base_url + endpoint,
    data: ajax_data
  });
}
